// extracted by mini-css-extract-plugin
module.exports = {"TempNavButtons":"temp-nav-buttons_TempNavButtons__BA8l2"};